(function () {
  var SECTION_SELECTOR = '.oddit-section-scrolling-banner';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    function handleReducedMotionChange(e) {
      if (e.matches) {
        disable();
      } else {
        enable();
      }
    }

    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', handleReducedMotionChange);
    } else if (typeof reducedMotion.addListener === 'function') {
      reducedMotion.addListener(handleReducedMotionChange);
    }

    function handleVisibilityChange() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return {
      ro: ro,
      reducedMotion: reducedMotion,
      handleReducedMotionChange: handleReducedMotionChange,
      handleVisibilityChange: handleVisibilityChange,
    };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.reducedMotion && state.handleReducedMotionChange) {
      if (typeof state.reducedMotion.removeEventListener === 'function') {
        state.reducedMotion.removeEventListener('change', state.handleReducedMotionChange);
      } else if (typeof state.reducedMotion.removeListener === 'function') {
        state.reducedMotion.removeListener(state.handleReducedMotionChange);
      }
    }
    if (state.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', state.handleVisibilityChange);
    }
  }

  function initSection(section) {
    if (!section || !section.id) return;
    if (sectionState.has(section.id)) return;
    var state = { marquee: initMarquee(section) };
    sectionState.set(section.id, state);
  }

  function destroySection(section) {
    if (!section || !section.id) return;
    var state = sectionState.get(section.id);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section.id);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) destroySection(section);
  });
})();